"use client";

var _excluded = ["id", "open", "onClose", "initialFocus", "role", "autoFocus", "__demoMode", "unmount"],
  _excluded2 = ["transition", "open"],
  _excluded3 = ["id", "transition"],
  _excluded4 = ["transition"],
  _excluded5 = ["id"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import n, { Fragment as H, createContext as le, createRef as ae, useContext as ie, useEffect as pe, useMemo as E, useReducer as se, useRef as N } from "react";
import { useEscape as de } from '../../hooks/use-escape.js';
import { useEvent as A } from '../../hooks/use-event.js';
import { useId as I } from '../../hooks/use-id.js';
import { useInertOthers as ue } from '../../hooks/use-inert-others.js';
import { useIsTouchDevice as Te } from '../../hooks/use-is-touch-device.js';
import { useOnDisappear as fe } from '../../hooks/use-on-disappear.js';
import { useOutsideClick as ge } from '../../hooks/use-outside-click.js';
import { useOwnerDocument as me } from '../../hooks/use-owner.js';
import { MainTreeProvider as W, useMainTreeNode as ce, useRootContainers as De } from '../../hooks/use-root-containers.js';
import { useScrollLock as Pe } from '../../hooks/use-scroll-lock.js';
import { useServerHandoffComplete as ye } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as M } from '../../hooks/use-sync-refs.js';
import { CloseProvider as Ee } from '../../internal/close-provider.js';
import { ResetOpenClosedProvider as Ae, State as R, useOpenClosed as $ } from '../../internal/open-closed.js';
import { ForcePortalRoot as j } from '../../internal/portal-force-root.js';
import { match as _e } from '../../utils/match.js';
import { RenderFeatures as Y, forwardRefWithAs as _, render as x } from '../../utils/render.js';
import { Description as J, useDescriptions as Ce } from '../description/description.js';
import { FocusTrap as Fe, FocusTrapFeatures as C } from '../focus-trap/focus-trap.js';
import { Portal as be, PortalGroup as ve, useNestedPortals as Re } from '../portal/portal.js';
import { Transition as xe, TransitionChild as K } from '../transition/transition.js';
var Le = function (o) {
    return o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o;
  }(Le || {}),
  Oe = function (t) {
    return t[t.SetTitleId = 0] = "SetTitleId", t;
  }(Oe || {});
var he = _defineProperty({}, 0, function _(e, t) {
    return e.titleId === t.id ? e : _objectSpread(_objectSpread({}, e), {}, {
      titleId: t.id
    });
  }),
  w = /*#__PURE__*/le(null);
w.displayName = "DialogContext";
function L(e) {
  var t = ie(w);
  if (t === null) {
    var o = new Error("<".concat(e, " /> is missing a parent <Dialog /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, L), o;
  }
  return t;
}
function Se(e, t) {
  return _e(t.type, he, e, t);
}
var X = _(function (t, o) {
    var a = I(),
      _t$id = t.id,
      l = _t$id === void 0 ? "headlessui-dialog-".concat(a) : _t$id,
      i = t.open,
      p = t.onClose,
      d = t.initialFocus,
      _t$role = t.role,
      s = _t$role === void 0 ? "dialog" : _t$role,
      _t$autoFocus = t.autoFocus,
      c = _t$autoFocus === void 0 ? !0 : _t$autoFocus,
      _t$__demoMode = t.__demoMode,
      f = _t$__demoMode === void 0 ? !1 : _t$__demoMode,
      _t$unmount = t.unmount,
      D = _t$unmount === void 0 ? !1 : _t$unmount,
      O = _objectWithoutProperties(t, _excluded),
      h = N(!1);
    s = function () {
      return s === "dialog" || s === "alertdialog" ? s : (h.current || (h.current = !0, console.warn("Invalid role [".concat(s, "] passed to <Dialog />. Only `dialog` and and `alertdialog` are supported. Using `dialog` instead."))), "dialog");
    }();
    var P = $();
    i === void 0 && P !== null && (i = (P & R.Open) === R.Open);
    var u = N(null),
      V = M(u, o),
      F = me(u),
      T = i ? 0 : 1,
      _se = se(Se, {
        titleId: null,
        descriptionId: null,
        panelRef: /*#__PURE__*/ae()
      }),
      _se2 = _slicedToArray(_se, 2),
      b = _se2[0],
      q = _se2[1],
      g = A(function () {
        return p(!1);
      }),
      G = A(function (r) {
        return q({
          type: 0,
          id: r
        });
      }),
      m = ye() ? T === 0 : !1,
      _Re = Re(),
      _Re2 = _slicedToArray(_Re, 2),
      z = _Re2[0],
      Q = _Re2[1],
      Z = {
        get current() {
          var r;
          return (r = b.panelRef.current) != null ? r : u.current;
        }
      },
      v = ce(),
      _De = De({
        mainTreeNode: v,
        portals: z,
        defaultContainers: [Z]
      }),
      S = _De.resolveContainers,
      k = P !== null ? (P & R.Closing) === R.Closing : !1;
    ue(f || k ? !1 : m, {
      allowed: A(function () {
        var r, U;
        return [(U = (r = u.current) == null ? void 0 : r.closest("[data-headlessui-portal]")) != null ? U : null];
      }),
      disallowed: A(function () {
        var r;
        return [(r = v == null ? void 0 : v.closest("body > *:not(#headlessui-portal-root)")) != null ? r : null];
      })
    }), ge(m, S, function (r) {
      r.preventDefault(), g();
    }), de(m, F == null ? void 0 : F.defaultView, function (r) {
      r.preventDefault(), r.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), g();
    }), Pe(f || k ? !1 : m, F, S), fe(m, u, g);
    var _Ce = Ce(),
      _Ce2 = _slicedToArray(_Ce, 2),
      ee = _Ce2[0],
      te = _Ce2[1],
      oe = E(function () {
        return [{
          dialogState: T,
          close: g,
          setTitleId: G,
          unmount: D
        }, b];
      }, [T, b, g, G, D]),
      B = E(function () {
        return {
          open: T === 0
        };
      }, [T]),
      ne = {
        ref: V,
        id: l,
        role: s,
        tabIndex: -1,
        "aria-modal": f ? void 0 : T === 0 ? !0 : void 0,
        "aria-labelledby": b.titleId,
        "aria-describedby": ee,
        unmount: D
      },
      re = !Te(),
      y = C.None;
    return m && !f && (y |= C.RestoreFocus, y |= C.TabLock, c && (y |= C.AutoFocus), re && (y |= C.InitialFocus)), /*#__PURE__*/n.createElement(Ae, null, /*#__PURE__*/n.createElement(j, {
      force: !0
    }, /*#__PURE__*/n.createElement(be, null, /*#__PURE__*/n.createElement(w.Provider, {
      value: oe
    }, /*#__PURE__*/n.createElement(ve, {
      target: u
    }, /*#__PURE__*/n.createElement(j, {
      force: !1
    }, /*#__PURE__*/n.createElement(te, {
      slot: B
    }, /*#__PURE__*/n.createElement(Q, null, /*#__PURE__*/n.createElement(Fe, {
      initialFocus: d,
      initialFocusFallback: u,
      containers: S,
      features: y
    }, /*#__PURE__*/n.createElement(Ee, {
      value: g
    }, x({
      ourProps: ne,
      theirProps: O,
      slot: B,
      defaultTag: Ie,
      features: Me,
      visible: T === 0,
      name: "Dialog"
    })))))))))));
  }),
  Ie = "div",
  Me = Y.RenderStrategy | Y.Static;
function we(e, t) {
  var _e$transition = e.transition,
    o = _e$transition === void 0 ? !1 : _e$transition,
    a = e.open,
    l = _objectWithoutProperties(e, _excluded2),
    i = $(),
    p = e.hasOwnProperty("open") || i !== null,
    d = e.hasOwnProperty("onClose");
  if (!p && !d) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!p) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!d) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (!i && typeof e.open != "boolean") throw new Error("You provided an `open` prop to the `Dialog`, but the value is not a boolean. Received: ".concat(e.open));
  if (typeof e.onClose != "function") throw new Error("You provided an `onClose` prop to the `Dialog`, but the value is not a function. Received: ".concat(e.onClose));
  return (a !== void 0 || o) && !l.static ? /*#__PURE__*/n.createElement(W, null, /*#__PURE__*/n.createElement(xe, {
    show: a,
    transition: o,
    unmount: l.unmount
  }, /*#__PURE__*/n.createElement(X, _objectSpread({
    ref: t
  }, l)))) : /*#__PURE__*/n.createElement(W, null, /*#__PURE__*/n.createElement(X, _objectSpread({
    ref: t,
    open: a
  }, l)));
}
var Ge = "div";
function ke(e, t) {
  var o = I(),
    _e$id = e.id,
    a = _e$id === void 0 ? "headlessui-dialog-panel-".concat(o) : _e$id,
    _e$transition2 = e.transition,
    l = _e$transition2 === void 0 ? !1 : _e$transition2,
    i = _objectWithoutProperties(e, _excluded3),
    _L = L("Dialog.Panel"),
    _L2 = _slicedToArray(_L, 2),
    _L2$ = _L2[0],
    p = _L2$.dialogState,
    d = _L2$.unmount,
    s = _L2[1],
    c = M(t, s.panelRef),
    f = E(function () {
      return {
        open: p === 0
      };
    }, [p]),
    D = A(function (u) {
      u.stopPropagation();
    }),
    O = {
      ref: c,
      id: a,
      onClick: D
    };
  return /*#__PURE__*/n.createElement(l ? K : H, _objectSpread({}, l ? {
    unmount: d
  } : {}), x({
    ourProps: O,
    theirProps: i,
    slot: f,
    defaultTag: Ge,
    name: "Dialog.Panel"
  }));
}
var Be = "div";
function Ue(e, t) {
  var _e$transition3 = e.transition,
    o = _e$transition3 === void 0 ? !1 : _e$transition3,
    a = _objectWithoutProperties(e, _excluded4),
    _L3 = L("Dialog.Backdrop"),
    _L4 = _slicedToArray(_L3, 1),
    _L4$ = _L4[0],
    l = _L4$.dialogState,
    i = _L4$.unmount,
    p = E(function () {
      return {
        open: l === 0
      };
    }, [l]),
    d = {
      ref: t,
      "aria-hidden": !0
    };
  return /*#__PURE__*/n.createElement(o ? K : H, _objectSpread({}, o ? {
    unmount: i
  } : {}), x({
    ourProps: d,
    theirProps: a,
    slot: p,
    defaultTag: Be,
    name: "Dialog.Backdrop"
  }));
}
var He = "h2";
function Ne(e, t) {
  var o = I(),
    _e$id2 = e.id,
    a = _e$id2 === void 0 ? "headlessui-dialog-title-".concat(o) : _e$id2,
    l = _objectWithoutProperties(e, _excluded5),
    _L5 = L("Dialog.Title"),
    _L6 = _slicedToArray(_L5, 1),
    _L6$ = _L6[0],
    i = _L6$.dialogState,
    p = _L6$.setTitleId,
    d = M(t);
  pe(function () {
    return p(a), function () {
      return p(null);
    };
  }, [a, p]);
  var s = E(function () {
    return {
      open: i === 0
    };
  }, [i]);
  return x({
    ourProps: {
      ref: d,
      id: a
    },
    theirProps: l,
    slot: s,
    defaultTag: He,
    name: "Dialog.Title"
  });
}
var We = _(we),
  $e = _(ke),
  ct = _(Ue),
  je = _(Ne),
  Dt = J,
  Pt = Object.assign(We, {
    Panel: $e,
    Title: je,
    Description: J
  });
export { Pt as Dialog, ct as DialogBackdrop, Dt as DialogDescription, $e as DialogPanel, je as DialogTitle };